import { useDebouncedCallback } from 'use-debounce';
import { authGlobals } from '@tmapy/auth';

const DELAY_WHISPERER = 300;

type WhispererConfig = {
  getUrl: Function;
  setItems: Function;
  sendAuth: boolean;
};

export const useWhisperer = ({ getUrl, setItems, sendAuth }: WhispererConfig) => {
  return useDebouncedCallback(async (value: string) => {
    const headers = new Headers();
    if (sendAuth) {
      headers.append('Authorization', `Bearer ${authGlobals.token}`);
    }
    const response = await fetch(getUrl(value), {
      headers,
    });
    if (response.ok) {
      const data = await response.json();
      setItems(data);
    }
  }, DELAY_WHISPERER);
};
